import {
    BUSINESS_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { EVENTBRITE_CATEGORY_CAROUSEL_ICON_MAP } from '../../../constants/category';
import { Category } from '../types';
const CATEGORY_KEYS = [
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    BUSINESS_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
];

export const CATEGORIES: Category[] = CATEGORY_KEYS.map((category) => {
    return {
        key: EVENTBRITE_CATEGORY_TO_REFINEMENT[category],
        name: EVENTBRITE_CATEGORY_MAPPING[category],
        icon: EVENTBRITE_CATEGORY_CAROUSEL_ICON_MAP[category],
    };
});
